export default {
  general: {
    home: 'Home',
    save_failed: 'Saving failed.',
    print: 'Print',
    informations: 'Informations',
    dashboard: 'Dashboard',
    other: 'Other',
    club: 'Federation | Federations',
    registration_fee: 'Registration fee',
    registration_fee_discount: 'Registration fee discount',
    male: 'Male',
    female: 'Female',
    mixed: 'Mixed',
    save: 'Save',
    save_changes: 'Save Changes',
    type: 'Type',
    both: 'Both',
    men: 'Men',
    women: 'Women',
    cancel: 'Cancel',
    confirm: 'Confirm',
    remove: 'Remove',
    warning: 'Warning',
    edit: 'Edit',
    add: 'Add',
    create: 'Create',
    actions: 'Actions',
    next: 'Next',
    ops: 'Ooops!',
    prev_step: 'Previous step',
    page_doesnt_exists: "The page you are trying to access doesn't exist.",
    back_to_home: 'Back to home',
    function: 'Function',
    documents: 'Documents',
    images: 'Images',
    n0: 'No.',
    cover_image: 'Cover image',
    yes: 'Yes',
    no: 'No',
    change: 'Change',
    date: 'Date',
    close: 'Close',
    active: 'Active',
    archive: 'Archive',
    delete: 'Delete',
    unarchive: 'Unarchive',
    select_file: 'Select file',
    confirm_delete: 'Are you sure you want to delete {item}?',
    no_history: 'No history entries.',
    alphabetically: 'Alphabetically',
    latest_first: 'Latest first',
    oldest_first: 'Oldest first',
    by_club: 'By Federation',
    order_by: 'Order by',
    placement: 'Placement',
    rank: 'Rank',
    points: 'Points'
  },

  menu: {
    my_club: 'My Federation',
    ranking_list: 'Ranking List',
    ranking_sports_associations: 'Sports Associations',
    open_tournament: 'Open tournament',
    last_tournament: 'Previous tournament',
    open_seminar: 'Open Seminar',
    open_camp: 'Open Camp',
    admin_panel: 'Admin Panel',
    users: 'Users'
  },

  auth: {
    login: 'Login',
    log_out: 'Log out',
    register: 'Register',
    no_account_register: "Don't have an account? Register",
    have_account_login: 'Have an account? Log in',
    sign_in: 'Sign in',
    sign_up: 'Sign up',
    profile_information: 'Profile information',
    club_info: 'Federation information',
    forgot_password: 'Forgot password?',
    reset_password: 'Reset password',
    add_coach: 'Add Coach',
    add_referee: 'Add Referee',
    edit_coach: 'Edit Coach',
    edit_referee: 'Edit Referee',
    add_member: 'Add Member',
    edit_member: 'Edit Member'
  },

  form: {
    name: 'Name',
    first_name: 'First name',
    last_name: 'Last name',
    full_name: 'Full name',
    city: 'City',
    address: 'Address',
    username: 'Username',
    price: 'Price',
    website: 'Website',
    contact_person: 'Contact person',
    discount: 'Discount',
    description: 'Description',
    mobile: 'Phone number',
    email: 'Email',
    enter_email: 'Enter email',
    password: 'Password',
    repeat_password: 'Repeat password',
    enter_password: 'Enter password',
    image: 'Image',
    insurance: 'Insurance',
    insurance_company: 'Insurance Company',
    insurance_validity_start_date: 'Insurance Validity - Start Date',
    insurance_validity_end_date: 'Insurance Validity - End Date',
    medical_examination: 'Medical Examination',
    medical_examination_start_date: 'Medical Examination Start Date',
    medical_examination_end_date: 'Medical Examination End Date',
    insurance_document: 'Insurance document',
    medical_document: 'Medical examination document',
    other_documents: 'Other documents',
    date_of_birth: 'Date of birth',
    gender: 'Gender',
    belt: 'Belt',
    day: 'Day',
    font_size: 'Font size',
    font_family: 'Font family',
    no_certificate_wff: 'No. certificate WFF',
    no_referee_certificate_wff: 'No. referee certificate WFF',
    no_fudokan_passport: 'No. Fudokan Passport',
    earned_points: 'Earned Points',
    add_points: 'Add Points',
    change_history: 'Change History',
    modified_by: 'Modified By',
    points_history_manual: 'Manually added points',
    points_history_unknown: '—',
    points_history_by_user: 'By: {name}',
    points_history_by_system: 'Tournament system (automatic)',
    points_history_date_of_change: 'Date of change',
    points_history_points_added: 'Points added',
    points_history_points_change: 'Points change (from → to)',
    points_history_basis: 'Basis (participation or placement)',
    points_history_tournament_name: 'Tournament name',
    points_history_category: 'Category',
    points_history_discipline: 'Discipline'
  },

  tournament: {
    teams: 'Teams',
    competitors: 'Competitor | Competitors',
    tournament_name: 'Tournament name',
    tournament: 'Tournament | Tournaments',
    create_tournament: 'Create tournament',
    registered_competitors: 'Registered competitors',
    all_registered_competitors: 'All registered competitors',
    all_registered_teams: 'All registered teams',
    my_registered_competitors: 'My registered competitors',
    my_registered_teams: 'My registered teams',
    close_applications: 'Close applications',
    edit_tournament: 'Edit tournament',
    registration_start_date: 'Registration start date',
    registration_end_date: 'Registration end date',
    single_disciplines: 'Single disciplines',
    team_disciplines: 'Team disciplines',
    registration_fee_type: 'Registration fee type',
    registration_fee_type_placeholder: 'Select…',
    registration_fee_per_discipline: 'Per discipline',
    registration_fee_bundle: 'Bundle pricing',
    registration_fee_legacy: 'Legacy',
    price_per_discipline: 'Price per discipline',
    disciplines_or_more: 'disciplines or more',
    min_disciplines: 'Min. disciplines',
    add_fee_rule: 'Add.',
    bundle_fee_index_and_more: 'and more',
    fee_rules_required: 'Add at least one bundle fee rule.',
    fee_rules_invalid: 'Each rule must have at least 1 discipline and non-negative price and discount.',
    number_of_registered_competitors: 'Number of registered competitors',
    number_of_registered_disciplines: 'Number of registered disciplines',
    number_of_registered_team_disciplines: 'Number of registered team disciplines',
    number_of_registered_clubs: 'Number of registered Federations',
    total_podium_awards_required: 'Total podium awards required',
    gold_awards: 'Gold',
    silver_awards: 'Silver',
    bronze_awards: 'Bronze',
    ask_delete_tournament: 'Are you sure you want to delete this tournament',
    register_competitor: 'Register competitor',
    edit_competitor: 'Edit competitor',
    seeded_competitor: 'Seeded competitor',
    seeded_competitor_description: 'Seeded competitors will be separated in the bracket and cannot meet in early rounds.',
    register_team: 'Register team',
    assign_numbers: 'Assign Numbers',
    change_history: 'Change history',
    add_team: 'Add team',
    edit_team: 'Edit team',
    brackets: 'Brackets',
    bracket: 'Bracket',
    generate_draw: 'Generate Draw',
    generate_missing_draws: 'Generate Missing Draws',
    generate_missing_draws_warning: 'Draws will be generated only for disciplines that do not have one yet (e.g. competitors added later). Existing draws and results stay untouched. Continue?',
    missing_draws_generated: 'New draws generated: {count}',
    draw: 'Draw',
    regenerate_draw: 'Regenerate Draw',
    scoring_table_regenerated: 'Scoring table order has been regenerated.',
    no_competitors_in_bracket: 'No competitors in this bracket.',
    draw_model: 'Draw model',
    draw_model_skeleton: 'Bracket (skeleton)',
    general_overall_ranking: 'General ranking',
    winner: 'Winner',
    eliminations: 'Eliminations',
    unknown: 'Unknown',
    match: 'Match',
    winner_of_match: 'Winner of Match',
    recorder: 'Recorder',
    verified_by: 'Verified by',
    chief_judge: 'Chief Judge',
    bracket_generation_warning: 'After generating the draw, it will not be possible to modify or regenerate the draw. Are you sure you want to continue?',
    bracket_generation_requires_closed_registrations: 'Draw can only be generated after registrations are closed.',
    no_brackets_generated: 'Draw has not been generated yet.',
    brackets_generated_successfully: 'Draw generated successfully.',
    bracket_generation_failed: 'Error generating draw.',
    reset_brackets: 'Reset Brackets',
    bracket_reset_warning: 'This will permanently delete all bracket data (matches and brackets) for this tournament. This action cannot be undone. Are you sure you want to continue?',
    brackets_reset_successfully: 'Brackets have been reset successfully.',
    bracket_reset_failed: 'Error resetting brackets.',
    print_bracket: 'Print Bracket',
    print_brackets: 'Print Brackets',
    lock_bracket: 'Lock Bracket',
    lock_brackets: 'Lock Brackets',
    unlock_bracket: 'Unlock Bracket',
    unlock_brackets: 'Unlock Brackets',
    bracket_locked: 'Bracket Locked',
    bracket_unlocked: 'Bracket Unlocked',
    bracket_lock_warning: 'After locking the bracket, you will be able to enter match results. Are you sure you want to lock the bracket?',
    brackets_lock_warning: 'Lock all brackets and enable match result entry?',
    bracket_unlock_warning: 'After unlocking the bracket, you will not be able to enter match results. Existing data will not be deleted. Are you sure you want to unlock the bracket?',
    brackets_unlock_warning: 'Unlock all brackets? Match editing will be disabled.',
    bracket_locked_successfully: 'Bracket locked successfully.',
    brackets_locked_successfully: 'Brackets locked successfully.',
    bracket_unlocked_successfully: 'Bracket unlocked successfully.',
    brackets_unlocked_successfully: 'Brackets unlocked successfully.',
    bracket_lock_failed: 'Error locking bracket.',
    brackets_lock_failed: 'Error locking brackets.',
    bracket_unlock_failed: 'Error unlocking bracket.',
    brackets_unlock_failed: 'Error unlocking brackets.',
    award_participation_points: 'Award participation points',
    participation_points_awarded: 'Participation points have been awarded to competitors.',
    participation_points_award_failed: 'Error awarding participation points.',
    lock_bracket_to_enter_results: 'Lock the brackets to start entering match results.',
    general_info: 'General information',
    certificates: 'Certificates',
    certificate: 'Certificate',
    diploma: 'Diploma',
    document_types: 'Document Types',
    no_document_types: 'No document types yet.',
    add_document_type: 'Add Document Type',
    document_type_name_placeholder: 'e.g. Accreditation',
    certificate_image: 'Image',
    document_types_requires_saved_entity: 'Save the tournament/seminar first before adding document types.',
    variables: 'Variables',
    add_text_field: '+ Add text field',
    field_properties: 'Field Properties',
    text_align: 'Alignment',
    align_left: 'Left',
    align_center: 'Center',
    align_right: 'Right',
    font_size: 'Font size',
    text_color: 'Text color',
    line_height: 'Line height',
    box_height: 'Box height',
    drag_edge_to_resize: 'Drag the field\'s top/bottom edge to change its box height.',
    competitor_name: 'Competitor Name',
    competition: 'Tournament Name',
    place_position: 'Place/Position',
    discipline: 'Discipline',
    category: 'Category',
    role: 'Role',
    document_image_load_failed: 'Failed to load the document image for',
    diploma_document_type_missing: 'Create a "Diploma" document type first (in the Certificates panel) to print winner diplomas.',
    print_manually: 'Manual entry',
    parse_rows: 'Parse into rows',
    scoring: 'Scoring',
    first_place_points: 'First place',
    second_place_points: 'Second place',
    third_place_points: 'Third place',
    fourth_place_points: 'Fourth place',
    other_placements_points: 'Participation',
    diplomas: 'Diplomas',
    diploma_requires_placement: 'Diplomas require at least one assigned winner in a bracket.',
    winner_diplomas: 'Diplomas',
    diplomas_all_competitors: 'Diplomas for All Competitors',
    assign_placements_diplomas: 'Assign placements for diplomas to all competitors.',
    assign_placements_intro: 'Assign a placement to each competitor. Only competitors with a placement will get a diploma.',
    certificate_type: 'Certificate Type',
    certificate_target: 'Target',
    thank_you_letter: 'Thank You Letter',
    certificate_text_competitor: 'This certificate confirms participation in the tournament.',
    certificate_text_club: 'This certificate confirms the sports association\'s participation in the tournament.',
    diploma_text_competitor: 'This document confirms participation in the tournament.',
    diploma_text_club: 'This document confirms the sports association\'s participation in the tournament.',
    thank_you_text_competitor: 'Thank you for participating in the tournament.',
    thank_you_text_club: 'Thank you to the sports association for participating in the tournament.',
    acknowledgement: 'Acknowledgement',
    accreditation: 'Accreditation',
    acknowledgements: 'Acknowledgements',
    files_and_images: 'Documents and Images',
    club_information: 'Club information',
    basic_information: 'Basic Information',
    individual_disciplines: 'Individual disciplines',
    select_category: 'Select category',
    select_discipline: 'Select discipline',
    judges: 'Judges',
    edit_winner: 'Edit winner',
    select_winner: 'Select winner',
    choose_winner: 'Choose competitor',
    current_winner: 'Current winner',
    no_final_match: 'No final match',
    save_winner_failed: 'Error saving winner'
  },

  seminar: {
    seminar_name: 'Seminar name',
    seminar: 'Seminar',
    camp: 'Camp',
    seminars_and_camps: 'Seminars and Camps',
    create_seminar: 'Create',
    type_placeholder: 'Select type',
    applications: 'Applications',
    registered_participants: 'Registered participants',
    register_participant: 'Register participant',
    select_members: 'Select members',
    assign_positions: 'Assign positions',
    assign_positions_per_participant: 'Assign positions per participant',
    edit_positions: 'Edit positions',
    positions: 'Positions',
    number_of_registered_participants: 'Number of registered participants',
    Judge: 'Judge',
    Athlete: 'Athlete',
    'Judge Trainee': 'Judge Trainee',
    Instructor: 'Instructor',
    Examiner: 'Examiner',
    'Sports Official': 'Sports Worker',
    Companion: 'Companion',
    Coach: 'Coach',
    already_registered: 'Already registered'
  },

  club: {
    coach: 'Coach | Coaches',
    official: 'Official | Officials',
    member: 'Member | Members',
    referee: 'Referee | Referees',
    referee_rang: 'Referee rang',
    club_name: 'Federation name',
    function: 'Function',
    add_official: 'Add official',
    edit_official: 'Edit official',
    add_member: 'Add member',
    short_name: 'Short federation name',
    my_federation_information: 'My federation information',
    ask_delete_club: 'Are you sure you want to delete this federation',
    ask_undelete_club: 'Are you sure you want to restore this federation',
    active_clubs: 'Active',
    deleted_clubs: 'Archive',
    undelete: 'Undelete',
    registration_fee_free: 'Registration fee free',
    must_pay_registration_fee: 'Must pay registration fee'
  },

  profile: {
    my_profile: 'My profile',
    profile_settings: 'Profile settings',
    change_password: 'Change password',
    current_password: 'Current password',
    new_password: 'New password'
  },

  settings: {
    settings: 'Settings',
    category: 'Category | Categories',
    discipline: 'Discipline | Disciplines',
    allowed_sexes: 'Allowed sexes',
    general_settings: 'General settings',
    website_name: 'Website name',
    website_description: 'Website description',
    logo: 'Logo',
    create_category: 'Create category',
    create_discipline: 'Create discipline',
    edit_discipline: 'Edit discipline',
    edit_category: 'Edit category',
    one_discipline: 'One discipline',
    two_disciplines: 'Two disciplines',
    three_or_more_disciplines: 'Three or more disciplines',
    team_disciplines: 'Team disciplines',
    discipline_always_chargeable: 'This discipline is always chargeable',
    discipline_not_chargeable: 'This discipline is not chargeable',
    category_not_chargeable: 'This category is not chargeable',
    number_of_podium_places: 'Number of podium places',
    podium_places_3: '3 podium places (1st, 2nd, 3rd)',
    podium_places_4: '4 podium places (1st, 2nd, 3rd, 4th / two bronzes)',
    reset_points_title: 'Reset points and medals',
    reset_points_help: 'Sets all earned points and medal counts for clubs and competitors to zero. Tournaments, brackets, and match results are preserved, but the per-tournament ranking view will no longer show points earned in past tournaments.',
    reset_points_button: 'Reset points and medals'
  },

  messages: {
    success_sign_in: 'Signed in successfully.',
    error_email_password_combination: 'Wrong email/password combination.',
    success_register: 'You have successfully registered. You can log in now.',
    settings_successfully_updated: 'Settings successfully updated.',
    ask_reset_points: 'Are you sure you want to reset all points and medals for clubs and competitors? Tournaments and brackets will not be changed.',
    points_successfully_reset: 'All points and medals have been successfully reset.',
    success_remove_discipline: 'Discipline successfully removed.',
    success_remove_category: 'Category successfully removed.',
    ask_remove_discipline: 'Are you sure you want to remove this discipline',
    ask_remove_category: 'Are you sure you want to remove this category',
    ask_remove_coach: 'Are you sure you want to remove this coach',
    ask_remove_team: 'Are you sure you want to remove this team',
    ask_remove_referee: 'Are you sure you want to remove this referee',
    ask_delete_official: 'Are you sure you want to delete this official',
    ask_delete_tournament: 'Are you sure you want to delete this tournament?',
    ask_delete_seminar: 'Are you sure you want to delete this seminar?',
    ask_delete_camp: 'Are you sure you want to delete this camp?',
    ask_assign_numbers: 'Are you sure you want to assign numbers to competitors?',
    success_updated_referee: 'Successfully updated referee.',
    success_created_referee: 'Successfully created referee.',
    success_updated_official: 'Successfully updated official',
    success_created_official: 'Successfully created official.',
    success_updated_discipline: 'Successfully updated discipline.',
    success_created_discipline: 'Successfully created discipline.',
    success_updated_category: 'Successfully updated category.',
    success_created_category: 'Successfully created category.',
    success_updated_profile: 'Successfully updated profile.',
    success_changed_password: 'Password changed successfully.',
    success_deleted_tournament: 'Successfully deleted tournament.',
    success_deleted_seminar: 'Successfully deleted seminar.',
    success_deleted_camp: 'Successfully deleted camp.',
    success_deleted_team: 'Successfully deleted team.',
    success_deleted_referee: 'Successfully deleted referee.',
    success_deleted_club: 'Successfully deleted federation.',
    success_restored_club: 'Successfully restored federation.',
    success_deleted_official: 'Successfully deleted official.',
    success_deleted_coach: 'Successfully deleted coach.',
    success_updated_coach: 'Successfully updated coach.',
    success_created_coach: 'Successfully created coach.',
    success_forgot_password_request: 'Successfully sent request for password reset. Check your email.',
    error_unknown: 'There was an error. Please try again.',
    error_unknown_account_email: 'There is no account with this email.',
    success_reset_password: 'Password reset successfully. You can log in now.',
    success_assign_numbers: 'Successfully assigned numbers to competitors.',
    error_enter_at_least_one_discipline: 'You must enter at least one discipline.',
    success_updated_competitor: 'Successfully updated competitor.',
    success_registered_competitor: 'Successfully registered competitor.',
    ask_remove_competitor: 'Are you sure you want to remove this competitor',
    success_remove_competitor: 'Successfully removed competitor.',
    error_number_of_selected_competitors: 'Number of selected competitors must be 2, 3 or 4.',
    error_select_at_least_one_discipline: 'You must select at least one discipline.',
    success_updated_team: 'Successfully updated a team.',
    success_registered_team: 'Successfully registered a team.',
    success_updated_member: 'Successfully updated a member.',
    success_created_member: 'Successfully created a member.',
    insurance_document_required: 'The insurance document is required because the date has changed.',
    medical_document_required: 'The medical examination document is required because the date has changed.',
    ask_archive_tournament: 'Are you sure you want to archive this tournament',
    ask_archive_seminar: 'Are you sure you want to archive this seminar?',
    ask_archive_camp: 'Are you sure you want to archive this camp?',
    ask_unarchive_tournament: 'Are you sure you want to unarchive this tournament',
    success_archived_tournament: 'Successfully archived tournament.',
    success_archived_seminar: 'Successfully archived seminar.',
    success_archived_camp: 'Successfully archived camp.',
    success_unarchived_tournament: 'Successfully unarchived tournament.'
  },

  validation: {
    required: 'This field is required.',
    isTruthy: 'This field is required.',
    email: 'Enter a valid email address.',
    integer: 'This field must be a number.',
    url: 'Enter a valid URL.',
    minLength: 'More characters needed.',
    sameAsPassword: 'Passwords must match.'
  },

  changes: {
    REGISTER_COMPETITOR: 'registered competitor',
    COMPETITOR_UPDATE: 'updated competitor',
    COMPETITOR_DELETE: 'deleted competitor',
    REGISTER_TEAM: 'registered a team',
    TEAM_UPDATE: 'updated team',
    TEAM_DELETE: 'deleted team',
    REGISTER_PARTICIPANT: 'registered participant',
    REMOVE_PARTICIPANT: 'removed participant',
    UPDATE_PARTICIPANT: 'updated participant'
  },

  referee_rangs: {
    NATIONAL_A: 'National A',
    NATIONAL_B: 'National B',
    NATIONAL_C: 'National C',
    TRAINEE: 'Trainee',
    OTHER: 'Other'
  }
}
